import React from "react";
import {
  ModalContent,
  ModelWrapper,
  FlexWrapper,
  ModalHeader,
  ModalContentView,
} from "./StyledComponents";
import Button from "./Button";
import { Circle } from "./Overlay";
import styled from "styled-components";

const LoaderContainer = styled.div`
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  justify-content: center;
  background-color: rgb(0, 0, 0, 0.3);
  align-items: center;
`;

function Modal({
  title,
  onSubmit,
  onCancel,
  children,
  isLoading,
  isDisabled,
  confirmTitle,
  cancelTitle,
  width,
}) {
  return (
    <ModelWrapper display="flex">
      <ModalContent
        width={width ? width : "550px"}
        css={`
          @media (max-width: 768px) {
            width: 100% !important;
          }
        `}
      >
        <ModalContentView>
          {children}
          <FlexWrapper
            direction="row"
            justifyContent="center"
            viewPadding="0 0 10px 0"
          >
            {confirmTitle ? (
              <Button
                onClick={() => (onSubmit ? onSubmit() : null)}
                label={confirmTitle}
                margin="0 5px"
                labelColor="#fff"
                type="submit"
                // isLoading={isLoading}
                disabled={isDisabled || isLoading}
              />
            ) : null}

            {cancelTitle && (
              <Button
                onClick={() => (onCancel ? onCancel() : null)}
                label={cancelTitle}
                margin="0 5px"
                bgColor="#dbdbdb"
                labelColor="#000000"
              ></Button>
            )}
          </FlexWrapper>
        </ModalContentView>
      </ModalContent>
      {isLoading && (
        <LoaderContainer>
          <Circle size="Large" />
        </LoaderContainer>
      )}
    </ModelWrapper>
  );
}
export default Modal;
